import {TheCageSymbol, TheCageSymbolStates} from "./TheCageSymbol";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {gsap} from "gsap";
import {ReelView} from "../../core/reel/simplereel/SimpleReelModel";


export class ScatterSymbol extends TheCageSymbol {
    private readyToDestroy:boolean = true;


    constructor(symbolName:string, initState:TheCageSymbolStates, reelsView: ReelView) {
        super(symbolName, initState, reelsView);

        const spine = this.getSymbolSpine(this.symbolName, true);
        SpineGSAPWrapper.clearAnimation(spine!, 0,0);

    }


    destroy(options?:{children?:boolean; texture?:boolean; baseTexture?:boolean}) {
        if (this.readyToDestroy){
            const spine = this.getSymbolSpine(this.symbolName, true);
            spine?.skeleton.setSkin(null);
            spine?.state.setEmptyAnimation(0,0);
            spine?.state.setEmptyAnimation(1,0);
            spine?.state.setEmptyAnimation(2,0);
            spine?.state.setEmptyAnimation(3,0);
            super.destroy(options);
        }
    }


    getStateAnimation(state:TheCageSymbolStates):gsap.core.Timeline {
        return super.getStateAnimation(state);
    }

    protected getExplosionAnimation():gsap.core.Timeline {

        const tl = gsap.timeline();

        this.readyToDestroy = false;

        const spine = this.getSymbolSpine(this.symbolName, true);
        tl.add(() => this.moveToOverlayLayer());
        if (spine){
            tl.add(()=>{
                this.view.addChild(spine);
                this.setState(TheCageSymbolStates.EXPLODE, "none");
            })
            tl.add(SpineGSAPWrapper.createTimeline(spine, 0, "explode",0,1,0.1));
            tl.add(()=>{
                this.readyToDestroy = true;
                this.destroy();
            });
        }

        return tl;
    }

    public getTransitionWinFlyStart():gsap.core.Timeline {
        const tl = gsap.timeline();
        const spine = this.getSymbolSpine(this.symbolName, true);
        if (spine){
            tl.add(()=>{
                this.view.addChild(spine);
                this.setState(TheCageSymbolStates.NORMAL, "none");
                spine.updateTransform();
            })
        }
        tl.add(SpineGSAPWrapper.createTimeline(spine!, 0, `winFlyStart`,0,1,0.1));
        tl.add(SpineGSAPWrapper.createTimeline(spine!, 0, `winFlyLoop`,-1,1,0.1));
        return tl;
    }

    public getTransitionWinFlyEnd():gsap.core.Timeline {
        const tl = gsap.timeline();
        const spine = this.getSymbolSpine(this.symbolName, true);
        if (spine){
            tl.add(()=>{
                this.view.addChild(spine);
                spine.updateTransform();
            })
        }
        tl.add(SpineGSAPWrapper.createTimeline(spine!, 0, `winFlyEnd`,0,1,0.1));
        return tl;
    }

    public getWinAnimation(state:TheCageSymbolStates):gsap.core.Timeline {
        const tl = gsap.timeline();

        const spine = this.getSymbolSpine(this.symbolName, true);
        const spineState  = spine!.state.getCurrent(0);
        const isAlreadyLooping = spineState?.animation?.name == "winFlyStart" || spineState?.animation?.name == "anticipation_win";
        if (isAlreadyLooping){
            return tl;
        }

        tl.add(() => {
            this.moveToWinLayer();
            this.view.addChild(spine!);
            spine!.autoUpdate = true;
            spine!.updateTransform();
            this.setState(TheCageSymbolStates.WIN_TINY, "none");
        });
        tl.add(SpineGSAPWrapper.createTimeline(spine!, 0, `anticipation_win`,-1,1,0.25));

        return tl;
    }

    protected getLandingAnimation(state:TheCageSymbolStates):gsap.core.Timeline {

        const tl = gsap.timeline();
        const spine = this.getSymbolSpine(this.symbolName, true);
        tl.add(() => this.moveToWinLayer());
        if (spine){
            tl.add(()=>{
                this.view.addChild(spine);
                spine.updateTransform();
                this.setState(TheCageSymbolStates.LANDING, "none");
            })
            tl.add(SpineGSAPWrapper.createTimeline(spine, 0, `land`,0,1,0));
        }

        return tl;
    }

    protected getAttentionAnimation(state:TheCageSymbolStates):gsap.core.Timeline {
        const tl = gsap.timeline();

        if (!this.readyToDestroy){
            return tl;
        }

        const spine = this.getSymbolSpine(this.symbolName, true);

        const isAlreadyLooping = spine!.state.getCurrent(0)?.animation?.name == "anticipation_loop";
        if (isAlreadyLooping){
            return tl;
        }

        tl.add(() => this.moveToWinLayer());
        if (spine){
            tl.add(()=>{
                this.view.addChild(spine);
                this.setState(state, "none");
            })
            tl.add(SpineGSAPWrapper.createTimeline(spine, 0, `anticipation_loop`,-1, 1, 0.2));
        }

        return tl;
    }

    public getIdleAnimation(loopStartOffset:number = 0):gsap.core.Timeline {
        const tl = gsap.timeline();
        const spine = this.getSymbolSpine(this.symbolName, true);

        const isAlreadyLooping = spine!.state.getCurrent(0)?.animation?.name == "idle";
        if (isAlreadyLooping){
            return tl;
        }

        tl.add(() => this.moveToWinLayer());
        if (spine){
            tl.add(()=>{
                this.view.addChild(spine);
                this.setState(TheCageSymbolStates.NORMAL, "none");
            })
            tl.add(SpineGSAPWrapper.createTimeline(spine, 0, `idleStill`,0, 1, 0.2));
            tl.add(SpineGSAPWrapper.createTimeline(spine, 0, `idle`,-1, 1, 0.2), `>${loopStartOffset}`);
        }

        return tl;
    }
}